export enum CustomerSortingType {
	CustomerIdAscending = 0,
	CustomerIdDescending = 1,
	FirmaAscending = 2,
	FirmaDescending = 3,
	VornameAscending = 4,
	VornameDescending = 5,
	NachnameAscending = 6,
	NachnameDescending = 7,
	RegisteredAscending = 8,
	RegisteredDescending = 9,
	FirstOrderAscending = 10,
	FirstOrderDescending = 11,
	LastOrderAscending = 12,
	LastOrderDescending = 13,
	NumberOfArticlesAscending = 14,
	NumberOfArticlesDescending = 15,
	NumberOfOrdersAscending = 16,
	NumberOfOrdersDescending = 17,
	OrderSumAscending = 18,
	OrderSumDescending = 19,
}
